// extracted by mini-css-extract-plugin
module.exports = {"container":"Desktop_container__1y6JU"};